import { apiGet, apiPost, apiPut } from '@/api/client';
import type { Document, DocumentAudience, DocumentCategory, DocumentStatus } from '@/api/types';

export function listDocuments(companyId: string): Promise<Document[]> {
  return apiGet('/companies/{companyId}/documents', {
    params: { companyId },
  }) as unknown as Promise<Document[]>;
}

export interface NewDocumentInput {
  title: string;
  category: DocumentCategory;
  target_audience: DocumentAudience;
  file_url: string;
  requires_read_confirmation?: boolean;
  status?: DocumentStatus;
}

export function createDocument(
  companyId: string,
  input: NewDocumentInput,
): Promise<{ document_id: string }> {
  return apiPost('/companies/{companyId}/documents', {
    params: { companyId },
    body: input,
  }) as unknown as Promise<{ document_id: string }>;
}

/** Changes a document's status (gepubliceerd <-> archief). */
export function setDocumentStatus(
  companyId: string,
  documentId: string,
  status: DocumentStatus,
): Promise<{ document_id: string; status: DocumentStatus }> {
  return apiPut('/companies/{companyId}/documents/{documentId}', {
    params: { companyId, documentId },
    body: { status },
  }) as unknown as Promise<{ document_id: string; status: DocumentStatus }>;
}
